
export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-6">
            <span className="text-purple-600">◆</span>
            <span className="text-xs uppercase tracking-widest text-gray-500 font-medium">
              Who We Are
            </span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
            Expert Team Building<br />Modern iOS Applications
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            MADRAS DOO SVILAJNAC is a dedicated team of experts specializing in the development of modern applications for the iOS platform. Our mission is to create innovative solutions that enhance user experience and improve the security of mobile devices. With a deep understanding of iOS technologies and user needs, we deliver products that combine functionality, performance, and elegant design. Our commitment to excellence drives us to continuously innovate and provide applications that users can trust and rely on every day.
          </p>
        </div>
      </div>
    </section>
  );
}
